import { Plugin, PluginKey } from 'prosemirror-state';

import { EditorView } from '@lyearn/lygo-core';

const key = new PluginKey('handle-event-plugin');

export interface HandleEventProps {
  onKeyDown: (view: EditorView, event: KeyboardEvent) => boolean;
}

const getHandleEventPlugin = ({ onKeyDown }: HandleEventProps) => {
  return [
    new Plugin({
      key,
      props: {
        handleKeyDown: onKeyDown,
        handlePaste: (view, event, slice) => {
          return false;
        },
      },
    }),
  ];
};

export default getHandleEventPlugin;
